<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>

						<div class="modal-header row" style="justify-content: flex-end;">
							<!-- <div class="col-6">
							<button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
							</div> -->
							<div class="col">
							<button type="button" class="close" @click="$emit('closeModal')">
								<span aria-hidden="true">&times;</span>
							</button>
							</div>
						</div>
						<!-- Start Modal Body -->
						<div class="modal-body">
							<h4 class="title">Detail Absensi Karyawan</h4>

							<table class="table table-borderless mt-4 mb-4">
								<tr>
									<td>
										<h6>Nama Pegawai :</h6>
									</td>
									<td>
										<h6>{{labourer_name}}</h6>
									</td>
								</tr>
								<tr>
									<td>
										<h6>Absensi Bulan Ini :</h6>
									</td>
									<td v-if="data">
										<h6>{{data.length}} / {{moment().month(month).year(year).endOf('month').businessDaysIntoMonth()}} Hari</h6>
									</td>
								</tr>
							</table>

							<div class="row row-space">
								<div class="col-12 col-md-6 mt-1">
									<label>Bulan :</label>
									<Multiselect 
										:options="options.month.map(x => x.value)"
										:custom-label="opt => options.month.find(x => x.value == opt).name"
										v-model="month"
									/>
								</div>
								<div class="col-12 col-md-6 mt-1">
									<label>Tahun :</label>
									<Multiselect 
										:options="options.year"
										v-model="year"
									/>
								</div>
							</div>


							
							<table class="table mt-4 text-center" v-if="data">
								<thead class="thead-dark">
									<th>Hari</th>
									<th>Jam Masuk</th>
									<th>Jam Pulang</th>
									<th>Status Absensi</th>
									<th >Deskripsi</th>
								</thead>
								<tbody v-for="(date, index) in moment().month(month - 1).year(year).monthBusinessDays()" :key="date.date()">
									<tr>
										<td>{{date.date() < 10 ? '0' + date.date() :  date.date()}} - {{month >= 10 ? month : '0' + month}} - {{year}}</td>
										<td>{{data.find(x => x.day == date.date()) ? data.find(x => x.day == date.date()).in_time : '-'}}</td>
										<td>{{data.find(x => x.day == date.date()) && data.find(x => x.day == date.date()).clock_out ? data.find(x => x.day == date.date()).out_time : '-'}}</td>
										<td>{{data.find(x => x.day == date.date()) && data.find(x => x.day == date.date()).is_waiver ? `Terizin`  : '-'}}</td>
										<td>{{data.find(x => x.day == date.date()) && data.find(x => x.day == date.date()).description ?  data.find(x => x.day == date.date()).description : '-'}}</td>
									</tr>
								</tbody>
							</table>

							<div class="row">
								<div class="col mt-5" style="text-align: center">
									<button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
									<!-- <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Tambah</button> -->
								</div>
							</div>

						</div>
						<!-- End Modal Body -->
					</div>
				</div>
			</div>
			<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
		</div>
  </div>

 
</transition>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment-business-days'

moment.updateLocale('us', {
   workingWeekdays: [1, 2, 3, 4, 5, 6]
});

export default {
	components : {
		Multiselect
	},
	data () {
		return {
			moment,
			description : '',
			options : this.$store.getters.getFilterOptions,
			month : parseInt(new moment().month()) + 1 ,
			year : new moment().year(),
			selectedData : null,
			data : null,
		}
	},
	watch : {
		month : function () {
			this.loadData()
		},
		year : function () {
			this.loadData()
		}
 	},
	mounted() {
		this.loadData ()
	},
	methods : {
		loadData () {
      let start = new moment().month(this.month - 1).year(this.year).date(1).format("Y-MM-DD")
      console.log(this.month)
			let end = new moment().month(this.month - 1).year(this.year).endOf('month').format("Y-MM-DD")

			let url =`/api/v1/attendance?start=${start}&end=${end}&pagination=false`

			this.$http.get(url)
			.then((resp) => {
				let data = resp.data.data

				let selectedData = []

				for(var i = 0 ; i < data.length ; i++) {
          let day = data[i].clock_in ? data[i].clock_in : data[i].clock_out
          data[i].in_time = data[i].clock_in ? new moment(new Date(data[i].clock_in)).format("hh:mm A") : '-'
          data[i].out_time = data[i].clock_out ? new moment(new Date(data[i].clock_out)).format("hh:mm A") : '-'
					data[i].day = day ? new moment(new Date(day)).date() : '-'

					if(data[i].labourer_id == this.labourer_id){
            selectedData.push(data[i])
            // console.log(data[i])
          }
            
            
				}

				this.data = selectedData
			})
			.catch((err) => {
				console.log(err)
			})
		}
	},
	props : ['labourer_id' , 'labourer_name']
}
</script>

<style>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


/* FILE DRAG N' DROP START */
.dropZone {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975A0;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
/* FILE DRAG N' DROP END */


</style>
